import { theme } from "@web-noise/core";

const config = {
  label: "open",
  color: theme.colors.accent2,
  textColor: theme.colors.highlight3,
  labelOpened: "close",
  colorOpened: theme.colors.accent3,
  textColorOpened: theme.colors.highlight3,
  isToggle: false,
};

export default config;
